import { useEffect, useState } from 'react';
import { axiosInstance } from '../App';
import { Sparkles, FileText, Inbox, Users, Building2, LayoutDashboard } from 'lucide-react';
import EsquarcioOverview from './esquarcio/EsquarcioOverview';
import EsquarcioInvoices from './esquarcio/EsquarcioInvoices';
import EsquarcioDocuments from './esquarcio/EsquarcioDocuments';
import EsquarcioClients from './esquarcio/EsquarcioClients';
import EsquarcioSettings from './esquarcio/EsquarcioSettings';

const TABS = [
  { key: 'overzicht', label: 'Overzicht', icon: LayoutDashboard },
  { key: 'facturen', label: 'Facturen (uitgaand)', icon: FileText },
  { key: 'inkomend', label: 'Inkomend (facturen & bonnen)', icon: Inbox },
  { key: 'klanten', label: 'Klanten', icon: Users },
  { key: 'bedrijf', label: 'Bedrijfsgegevens', icon: Building2 },
];

export default function Esquarcio({ user }) {
  const readOnly = user?.role === 'boekhouder';
  const [tab, setTab] = useState('overzicht');
  const [settings, setSettings] = useState(null);
  const loadSettings = () => axiosInstance.get('/esquarcio/settings').then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => { loadSettings(); }, []);

  return (
    <div className="space-y-6" data-testid="esquarcio-page">
      <div className="flex flex-wrap items-center justify-between gap-4 rounded-2xl bg-[#0f3b57] px-6 py-5 text-white">
        <div className="flex items-center gap-4">
          <div className="bg-white rounded-xl px-3 py-2 shadow-sm">
            <img src={settings?.logo_url || '/esquarcio-logo.jpg'} alt="Esquarcio" className="h-10 object-contain" data-testid="esquarcio-logo" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight" data-testid="esquarcio-title">{settings?.name || 'Esquarcio Schoonmaakbedrijf'}</h1>
            <p className="text-white/70 text-sm">Aparte administratie — KvK {settings?.kvk} · Btw {settings?.btw_id}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="px-3 py-1.5 rounded-full bg-white/10 flex items-center gap-1"><Sparkles className="w-3.5 h-3.5" /> Tweede bedrijf</span>
          {readOnly && <span className="px-3 py-1.5 rounded-full bg-white/10" data-testid="readonly-badge">Alleen lezen</span>}
        </div>
      </div>

      <div className="flex gap-1 border-b border-gray-200 overflow-x-auto" data-testid="esquarcio-tabs">
        {TABS.map((t) => (
          <button key={t.key} type="button" onClick={() => setTab(t.key)} data-testid={`esq-tab-${t.key}`}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === t.key ? 'border-[#0f3b57] text-[#0f3b57]' : 'border-transparent text-gray-500 hover:text-gray-800'}`}>
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>

      {tab === 'overzicht' && <EsquarcioOverview readOnly={readOnly} />}
      {tab === 'facturen' && <EsquarcioInvoices readOnly={readOnly} settings={settings} />}
      {tab === 'inkomend' && <EsquarcioDocuments readOnly={readOnly} />}
      {tab === 'klanten' && <EsquarcioClients readOnly={readOnly} />}
      {tab === 'bedrijf' && <EsquarcioSettings readOnly={readOnly} settings={settings} onSaved={loadSettings} />}
    </div>
  );
}
